module.exports = (theme) => ({
  ".editorial": {
    display: "flex",
    flexDirection: "column",
    wordWrap: "break-word",
    border: "0px solid rgba(0, 0, 0, 0.125)",
    paddingTop: theme("spacing.xl"),
    paddingBottom: theme("spacing.xl"),
    paddingLeft: "21px",
    paddingRight: "21px",
    marginBottom: "50px",
    marginLeft: "auto",
    marginRight: "auto",
    maxWidth: "400px",
    boxSizing: "content-box",
  },
  ".editorial-media": {
    overflow: "hidden",
  },
  ".editorial-media img": {
    overflow: "hidden",
    width: "100%",
    transition: "transform 200ms ease",
    transform: "scale(1)",
    margin: "0",
    marginBottom: theme("spacing.lg"),
    borderTopLeftRadius: "0",
    borderTopRightRadius: "0",
    maxHeight: "240px",
    objectFit: "cover",
  },
  ".editorial-media img:hover": {
    transform: "scale(1.1)",
  },
  ".editorial-media iframe": {
    width: "100%",
    border: "none",
  },
  ".editorial-content": {
    flex: "1 1 auto",
    padding: "0",
    color: "#222222",
  },
  ".editorial-heading": {
    color: "#222222",
    fontSize: theme("fontSize.3xl"),
    marginBottom: theme("spacing.lg"),
    marginTop: "20px",
    fontWeight: theme("fontWeight.bold"),
    lineHeight: theme("spacing.xl"),
  },
  ".editorial-heading-h2": {
    marginBottom: "24px",
    marginTop: "20px",
  },
  ".editorial-heading-h3": {
    marginBottom: "24px",
    marginTop: "20px",
  },
  ".editorial-heading-h4": {
    marginBottom: "24px",
    marginTop: "20px",
  },
  ".editorial-heading-h3-small": {
    fontSize: "24px",
    marginBottom: "24px",
    marginTop: "20px",
  },
  ".editorial-text": {
    lineHeight: theme("spacing.xl"),
    marginBottom: theme("spacing.lg"),
  },
  ".editorial-text h3": { paddingTop: theme("spacing.lg") },
  ".editorial-text h4": { paddingTop: theme("spacing.DEFAULT") },
  ".editorial-text p": { marginTop: theme("spacing.DEFAULT"), lineHeight: theme("spacing.xl") },
  ".editorial-text ul": {
    listStyle: "none",
    paddingLeft: "20px",
    marginTop: theme("spacing.DEFAULT"),
    marginBottom: theme("spacing.DEFAULT"),
  },
  ".editorial-text ul li": {
    padding: "0",
    lineHeight: theme("lineHeight.base"),
    paddingLeft: theme("spacing.sm"),
  },
  ".editorial-text ul li::before": {
    backgroundColor: theme("colors.primary.blue.DEFAULT"),
    borderRadius: "3px",
    display: "inline-block",
    marginRight: theme("spacing.sm"),
    padding: "3px",
    verticalAlign: "middle",
    content: '""',
    listStyle: "none",
    marginLeft: "-18px",
  },
  ".editorial-text ul[style*='list-style-type: check-mark;'] li": {
    listStyle: "none",
    paddingLeft: theme("spacing.sm"),
  },
  ".editorial-text ul[style*='list-style-type: check-mark;'] li::before": {
    backgroundColor: "inherit",
    padding: "0",
    fontFamily: '"Vattenfall Elements Icons", "Vattenfall Icons"',
    content: '"\\e97f"',
    marginRight: theme("spacing.sm"),
    marginLeft: "-34px",
    fontSize: theme("fontSize.2xl"),
    verticalAlign: "bottom",
  },
  ".editorial-text ol": {
    listStyle: "decimal",
    paddingLeft: theme("fontSize.xl"),
    marginTop: theme("spacing.DEFAULT"),
    marginBottom: theme("spacing.DEFAULT"),
  },
  ".editorial-text ol li": {
    padding: "0",
    paddingLeft: theme("spacing.sm"),
  },
  [`@media (max-width: ${theme("screens.sm")})`]: {
    ".editorial": {
      margin: "auto",
    },
  },
});
